import React, { useContext, useEffect, useState } from 'react';

import { GreetingModel, GuestModel } from '../../../../../../types/app';

import { WelcomeContainer } from '@/components/molecules';

import styles from './badge-individual.module.scss';
import { SocketContext } from '../../socket';
import { IoEvents } from '../../../../../../types/app/signal';
import { NAME_WAITING_TIME } from '../../../utils/constants';

interface IndividualViewProps {
  greeting: GreetingModel;
}

export const BadgeIndividualView: React.FC<IndividualViewProps> = ({ greeting }) => {
  const { persons } = greeting;
  const [ name, setName ] = useState(persons[0]?.firstName || '');
  const socket = useContext(SocketContext);

  useEffect(() => {
    socket && socket.on(IoEvents.queueNameReceived, (data) => {
      console.log('Message received: ', data);
      data?.firstName && setName(data.firstName);

      setTimeout(() => setName(persons[0]?.firstName), NAME_WAITING_TIME);
    });
  }, [socket]);

  return (
    <div
      className={styles['individual-view']}
    >
      <WelcomeContainer
        className={styles['individual-view__welcome']}
      >
        {name}
      </WelcomeContainer>
    </div>
  );
};
